export default "__VITE_ASSET__uz41Iug0__"